<template>
  <div class="main-box">
    <div class="mg-bt-10">
      <el-button type="primary" size="small" icon="el-icon-plus" @click="addMenu()">添加</el-button>
      <el-button type="danger" size="small" icon="el-icon-delete" @click="delMenu()">删除</el-button>
      <el-button type="warning" size="small" @click="dialogAllVisible=true">一键添加</el-button>
    </div>
    <el-table
        :data="tableData"
        ref="rfTable"
        row-key="id"
        style="width: 100%;"
        size="mini">
      <el-table-column
          type="selection"
          align="center"
          width="55">
      </el-table-column>
      <el-table-column
          prop="title"
          label="名称">
      </el-table-column>
      <el-table-column
          prop="ordering"
          label="排序"
          align="center"
          width="120">
      </el-table-column>
      <el-table-column
          prop="ftime"
          label="添加时间"
          align="center"
          width="140">
      </el-table-column>
      <el-table-column
          fixed="right"
          label="操作"
          align="center"
          width="100">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="editMenu(scope.row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
        background
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        layout="total, prev, pager, next, jumper"
        :page-sizes="[10, 20, 30, 40]"
        :total="search.total">
    </el-pagination>
    <el-dialog :title="menuTitle" :visible.sync="dialogFormVisible" custom-class="dialog" width="650px">
      <el-form :model="form" size="small">
        <el-form-item label="名称" :label-width="formLabelWidth">
          <el-input v-model="form.title" autocomplete="off" placeholder="请输入名称"></el-input>
        </el-form-item>
        <el-form-item label="排序" :label-width="formLabelWidth">
          <el-input v-model="form.ordering" autocomplete="off" placeholder="请输入排序"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="saveMenu" size="small">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="一键添加" :visible.sync="dialogAllVisible" custom-class="dialog" width="650px">
      <div class="notice-tip mg-bt-20">* 如果已经添加的单位，则不会重复添加！</div>
      <el-tag v-for="(item,index) in tags" :key="index" @click="chooseTag(item)" :effect="getChecked(item)" class="mg-rt-10 mg-bt-10 pt">{{item}}</el-tag>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogAllVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="saveAll()" size="small">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>

export default {
  components: {
  },
  data() {
    return {
      info: false,
      source_domain: this.config.SOURCE_DOMAIN,
      menuTitle: '添加单位',
      dialogFormVisible: false,
      dialogAllVisible: false,
      tags: ['件','只','个','头','台','斤','包','袋','箱','把','套','盒','瓶','对','卷','片'],
      chooseTags: [],
      form: {
        id: 0,
        pid: 0,
        title: '',
        ordering: ''
      },
      formLabelWidth: '120px',
      tableData: [],
      search: {
        current_page: 1,
        total: 0,
        limit: 10,
        keywords: ''
      },
    };
  },
  created() {
    this.getList();
  },
  mounted() {
  },
  computed: {
  },
  methods: {
    chooseTag(item) {
      if(this.chooseTags.indexOf(item) == -1) {
        this.chooseTags.push(item)
      } else {
        this.chooseTags.splice(this.chooseTags.indexOf(item),1)
      }
    },
    getChecked(item) {
      if(this.chooseTags.indexOf(item) != -1) {
        return 'dark'
      } else {
        return 'light'
      }
    },
    getList() {
      var that = this
      that.showLoading()
      var params = {
        page: that.search.current_page,
        page_size: that.search.limit,
        keywords: that.search.keywords
      }
      this.$api.goods.unitIndex(params, function (res) {
        that.hideLoading()
        if (res.errcode == 0) {
          that.tableData = res.data.data
          that.search.current_page = res.data.current_page
          that.search.total = res.data.total
        } else {
          that.fail(res.errmsg)
        }
      })
    },
    editMenu(item) {
      this.form = JSON.parse(JSON.stringify(item))
      this.dialogFormVisible = true
    },
    addMenu() {
      this.form.id = 0
      this.form.title = ''
      this.form.ordering = ''
      this.dialogFormVisible = true
    },
    saveMenu() {
      var that = this
      var param = {
        id: that.form.id,
        title: that.form.title,
        ordering: that.form.ordering,
      }
      if (this.form.id == 0) {
        this.$api.goods.unitAdd(param, function (res) {
          if (res.errcode == 0) {
            that.dialogFormVisible = false
            that.getList()
            that.success(res.errmsg)
          } else {
            that.fail(res.errmsg)
          }
        })
      } else {
        this.$api.goods.unitEdit(param, function (res) {
          if (res.errcode == 0) {
            that.dialogFormVisible = false
            that.getList()
            that.success(res.errmsg)
          } else {
            that.fail(res.errmsg)
          }
        })
      }
    },
    saveAll() {
      if(this.chooseTags.length<1) {
        this.tips('请选择添加单位')
        return false
      }
      var params = {
        items: this.chooseTags
      }
      this.$api.goods.unitAddAll(params, res => {
        if(res.errcode == 0) {
          this.success(res.errmsg)
          this.dialogAllVisible = false
          this.getList()
        } else {
          this.fail(res.errmsg)
        }
      })
    },
    delMenu() {
      var that = this
      var sel = this.$refs.rfTable.selection
      if (sel.length < 1) {
        that.tips('请选择删除项')
        return false
      }
      var ids = []
      sel.forEach(function (item) {
        ids.push(item.id)
      })
      this.$confirm('确认要删除这些数据吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$api.goods.unitDel({ids: ids}, function (res) {
          if (res.errcode == 0) {
            that.success('删除成功')
            that.getList()
          } else {
            that.fail(res.errmsg)
          }
        })
      }).catch(() => {

      });
    },
    handleSearch() {
      this.search.current_page = 1
      this.getList()
    },
    handleSelectionChange(rows) {
    },
    handleCurrentChange(val) {
      this.search.current_page = val
      this.getList()
    },
    handleSizeChange(val) {
      this.search.current_page = 1
      this.search.limit = val
      this.getList()
    }
  }
};
</script>
<style scoped>
</style>
